import { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Alert, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWallet, faPhone, faImage, faUpload, faCheckCircle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { BASE_URL } from "../App";
import ScrollTopButton from "./ScrollTop";
import "../styles/chargeRequest.css";
import Swal from 'sweetalert2';

function ChargeRequest({ style }) {
    const [formData, setFormData] = useState({
        amount: '',
        phone_number: '',
        image: null
    });
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingSettings, setIsLoadingSettings] = useState(true);
    const [message, setMessage] = useState({ type: '', text: '' });
    const [previewImage, setPreviewImage] = useState(null);
    const [settings, setSettings] = useState(null);
    const [walletProviderImage, setWalletProviderImage] = useState(null);

    // دالة لتحديد صورة شركة المحفظة حسب رقم الهاتف
    const getWalletProviderImage = (phoneNumber) => {
        if (!phoneNumber) return null;
        
        const cleanNumber = phoneNumber.replace(/\D/g, ''); // إزالة كل شيء ما عدا الأرقام
        console.log('رقم الهاتف النظيف:', cleanNumber);
        
        // اتصالات كاش: يبدأ بـ 011 فقط
        if (cleanNumber.startsWith('011')) {
            console.log('تم تحديد اتصالات كاش');
            return '/images/etisalat.png';
        }
        // فودافون كاش: يبدأ بـ 010 فقط
        else if (cleanNumber.startsWith('010')) {
            console.log('تم تحديد فودافون كاش');
            return '/images/vodaphone.png';
        }
        
        console.log('لم يتم تحديد شركة محفظة');
        return null;
    };

    // جلب إعدادات الشحن
    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`${BASE_URL}/api/charge-request-settings`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Accept': 'application/json'
                    }
                });
                if (response.data.success) {
                    setSettings(response.data.data);
                    
                    // عرض معلومات التشخيص
                    console.log('رقم المحفظة من API:', response.data.data.contact_phone);
                    const providerImage = getWalletProviderImage(response.data.data.contact_phone);
                    console.log('صورة الشركة المحددة:', providerImage);
                }
            } catch (error) {
                console.error('Error fetching settings:', error);
                
                // معالجة حالة 404
                if (error.response?.status === 404) {
                    setSettings(null); // إزالة الإعدادات
                    
                    // عرض SweetAlert للدفع المغلق
                    Swal.fire({
                        title: 'الدفع مغلق مؤقتاً! ⏰',
                        text: 'نعتذر، خدمة شحن الرصيد غير متاحة حالياً. يرجى المحاولة لاحقاً.',
                        icon: 'warning',
                        confirmButtonText: 'حسناً',
                        confirmButtonColor: '#ffc107',
                        background: style ? '#1f2937' : '#ffffff',
                        color: style ? '#f9fafb' : '#111827',
                        customClass: {
                            popup: style ? 'dark-swal' : 'light-swal',
                            title: style ? 'dark-swal-title' : 'light-swal-title',
                            content: style ? 'dark-swal-content' : 'light-swal-content'
                        }
                    });
                    
                    setMessage({ type: 'warning', text: 'الدفع مغلق مؤقتاً' });
                } else {
                    setMessage({ type: 'danger', text: 'حدث خطأ أثناء جلب إعدادات الشحن' });
                }
            } finally {
                setIsLoadingSettings(false);
            }
        };

        fetchSettings();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // إضافة تأثير بصري للخيار المحدد
        if (name === 'amount') {
            // إزالة class selected من جميع الخيارات
            document.querySelectorAll('.amount-option').forEach(option => {
                option.classList.remove('selected');
            });
            
            // إضافة class selected للخيار المحدد
            const selectedOption = e.target.closest('.amount-option');
            if (selectedOption) {
                selectedOption.classList.add('selected');
            }
        }

        // تحديث صورة شركة المحفظة عند تغيير رقم الهاتف
        if (name === 'phone_number') {
            const providerImage = getWalletProviderImage(value);
            console.log('رقم الهاتف:', value);
            console.log('صورة الشركة:', providerImage);
            setWalletProviderImage(providerImage);
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // التحقق من نوع الملف
            const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!allowedTypes.includes(file.type)) {
                setMessage({ type: 'danger', text: 'يرجى اختيار صورة بصيغة jpeg, png, jpg, أو gif' });
                return;
            }
            
            // التحقق من امتداد الملف
            const fileName = file.name.toLowerCase();
            const allowedExtensions = ['.jpg', '.jpeg', '.png', '.gif'];
            const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
            
            if (!hasValidExtension) {
                setMessage({ type: 'danger', text: 'امتداد الملف غير مسموح به. يرجى اختيار صورة بصيغة jpeg, png, jpg, أو gif' });
                return;
            }
            
            // التحقق من حجم الملف (أقل من 10MB)
            const maxSize = 10 * 1024 * 1024; // 10MB
            if (file.size > maxSize) {
                setMessage({ type: 'danger', text: 'حجم الصورة يجب أن يكون أقل من 10 ميجابايت' });
                return;
            }
            
            // التحقق من أن الملف ليس فارغاً
            if (file.size === 0) {
                setMessage({ type: 'danger', text: 'الملف فارغ. يرجى اختيار ملف صحيح' });
                return;
            }

            // التحقق من اسم الملف (منع الملفات المشبوهة)
            const suspiciousNames = ['virus', 'malware', 'trojan', 'backdoor', 'exploit', 'payload'];
            const fileNameLower = fileName.replace(/[^a-zA-Z0-9]/g, '');
            const hasSuspiciousName = suspiciousNames.some(name => fileNameLower.includes(name));
            
            if (hasSuspiciousName) {
                setMessage({ type: 'danger', text: 'اسم الملف مشبوه. يرجى اختيار ملف آخر' });
                return;
            }

            setFormData(prev => ({ ...prev, image: file }));
            
            // عرض معاينة الصورة
            const reader = new FileReader();
            reader.onload = (e) => setPreviewImage(e.target.result);
            reader.readAsDataURL(file);
            
            setMessage({ type: '', text: '' });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!formData.amount || !formData.phone_number || !formData.image) {
            setMessage({ type: 'danger', text: 'يرجى ملء جميع الحقول المطلوبة' });
            return;
        }

        // عرض رسالة تأكيد قبل الإرسال
        const result = await Swal.fire({
            title: 'هل أنت متأكد؟ 🤔',
            html: `
                <div class="confirmation-details">
                    <p><strong>تفاصيل الطلب:</strong></p>
                    <p>المبلغ: <span class="amount-highlight">${formData.amount} جنيه</span></p>
                    <p>رقم الهاتف: <span class="phone-highlight">${formData.phone_number}</span></p>
                    <p class="confirmation-warning">سيتم إرسال طلب شحن الرصيد. هل تريد المتابعة؟</p>
                </div>
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'نعم، أرسل الطلب ✅',
            cancelButtonText: 'لا، إلغاء ❌',
            confirmButtonColor: '#38017f',
            cancelButtonColor: '#6c757d',
            background: style ? '#1f2937' : '#ffffff',
            color: style ? '#f9fafb' : '#111827',
            customClass: {
                popup: style ? 'dark-swal' : 'light-swal',
                title: style ? 'dark-swal-title' : 'light-swal-title',
                content: style ? 'dark-swal-content' : 'light-swal-content',
                confirmButton: 'swal2-confirm',
                cancelButton: 'swal2-cancel'
            },
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
            }
        });

        // إذا لم يؤكد المستخدم، لا نتابع
        if (!result.isConfirmed) {
            return;
        }

        setIsLoading(true);
        setMessage({ type: '', text: '' });

        try {
            const token = localStorage.getItem('token');
            const formDataToSend = new FormData();
            formDataToSend.append('amount', formData.amount);
            formDataToSend.append('phone_number', formData.phone_number);
            formDataToSend.append('image', formData.image);

            const response = await axios.post(`${BASE_URL}/api/charge-request`, formDataToSend, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json'
                }
            });

            // عرض معلومات التشخيص
            console.log('استجابة API:', response.data);
            console.log('حالة الاستجابة:', response.data.status);
            console.log('رسالة الاستجابة:', response.data.message);

            // فحص نجاح الطلب (API يعيد status: "200")
            if (response.data.status === "200" || response.data.success) {
                console.log('تم نجاح الطلب، سيتم عرض SweetAlert');
                
                // التأكد من أن SweetAlert متاح
                if (typeof Swal !== 'undefined') {
                    console.log('SweetAlert متاح، سيتم عرضه');
                    
                                        // عرض SweetAlert للنجاح
                    Swal.fire({
                        title: 'تم الدفع بنجاح! 🎉',
                        text: 'انتظر رسالة التأكيد',
                        icon: 'success',
                        confirmButtonText: 'حسناً',
                        confirmButtonColor: '#38017f',
                        background: style ? '#1f2937' : '#ffffff',
                        color: style ? '#f9fafb' : '#111827',
                        customClass: {
                            popup: style ? 'dark-swal' : 'light-swal',
                            title: style ? 'dark-swal-title' : 'light-swal-title',
                            content: style ? 'dark-swal-content' : 'light-swal-content'
                        },
                        showClass: {
                            popup: 'animate__animated animate__fadeInDown'
                        },
                        hideClass: {
                            popup: 'animate__animated animate__fadeOutUp'
                        }
                    }).then((result) => {
                        console.log('تم إغلاق SweetAlert:', result);
                    });
                } else {
                    console.log('SweetAlert غير متاح');
                }

                // إعادة تعيين النموذج
                setFormData({ amount: '', phone_number: '', image: null });
                setPreviewImage(null);
                e.target.reset();
                
                // إزالة الرسالة السابقة
                setMessage({ type: '', text: '' });
                
                // عرض رسالة نجاح في النموذج أيضاً
                setMessage({ type: 'success', text: response.data.message || 'تم إرسال طلب الشحن بنجاح' });
            } else {
                console.log('فشل الطلب، الحالة:', response.data.status);
            }
        } catch (error) {
            console.error('Error submitting charge request:', error);
            const errorMessage = error.response?.data?.message || 'حدث خطأ أثناء إرسال طلب الشحن';
            
            // عرض SweetAlert للخطأ
            Swal.fire({
                title: 'حدث خطأ! ❌',
                text: errorMessage,
                icon: 'error',
                confirmButtonText: 'حسناً',
                confirmButtonColor: '#dc3545',
                background: style ? '#1f2937' : '#ffffff',
                color: style ? '#f9fafb' : '#111827',
                customClass: {
                    popup: style ? 'dark-swal' : 'light-swal',
                    title: style ? 'dark-swal-title' : 'light-swal-title',
                    content: style ? 'dark-swal-content' : 'light-swal-content'
                }
            });
            
            setMessage({ type: 'danger', text: errorMessage });
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoadingSettings) {
        return (
            <div className={`charge-request-page ${style ? 'dark-mode' : ''}`}>
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={6} md={8} sm={12}>
                            <div className="charge-request-card text-center">
                                <Spinner animation="border" variant={style ? 'light' : 'primary'} />
                                <p className="mt-3">جاري تحميل إعدادات الشحن...</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    return (
        <>
            <div className={`charge-request-page ${style ? 'dark-mode' : ''}`}>
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8} md={10} sm={12}>
                            <div className="charge-request-card">
                                <div className="card-header">
                                    <div className="header-icon">
                                        <FontAwesomeIcon icon={faWallet} />
                                    </div>
                                    <h1>طلب شحن الرصيد</h1>
                                    <p>أدخل بياناتك لإرسال طلب شحن الرصيد</p>
                                </div>
                                {settings?.instructions && (
                                    <div className="instructions-section mt-5 mb-5">
                                        <div className="instructions-header">
                                            <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                                            <h3>تعليمات الشحن</h3>
                                        </div>
                                        <div className="instructions-content">
                                            {settings.instructions.split('\r\n').map((instruction, index) => (
                                                <p key={index} className="instruction-item">
                                                    {instruction}
                                                </p>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {message.text && (
                                    <Alert variant={message.type === 'success' ? 'success' : message.type === 'warning' ? 'warning' : 'danger'} className="mt-3">
                                        <FontAwesomeIcon 
                                            icon={message.type === 'success' ? faCheckCircle : message.type === 'warning' ? faInfoCircle : faImage} 
                                            className="me-2" 
                                        />
                                        {message.text}
                                    </Alert>
                                )}

                                {/* عرض رسالة "الدفع مغلق مؤقتاً" عندما تكون الإعدادات غير متوفرة */}
                                {!settings && !isLoadingSettings && (
                                    <div className="payment-closed-message text-center py-5">
                                        <div className="closed-icon mb-3">
                                            <FontAwesomeIcon icon={faWallet} size="3x" className="text-muted" />
                                        </div>
                                        <h3 className="text-muted mb-3">الدفع مغلق مؤقتاً</h3>
                                        <p className="text-muted">نعتذر، خدمة شحن الرصيد غير متاحة حالياً. يرجى المحاولة لاحقاً.</p>
                                    </div>
                                )}

                                {/* عرض المحتوى فقط عندما تكون الإعدادات متوفرة */}
                                {settings && (
                                    <>
                                        <div className="contact-info mb-4">
                                            <div className="contact-phone">
                                                <div className="phone-info">
                                                    <FontAwesomeIcon icon={faPhone} className="me-2" />
                                                    <strong>رقم المحفظة المطلوب التحويل عليه:</strong>
                                                    <span className="phone-number">{settings.contact_phone}</span>
                                                </div>
                                                
                                                {/* عرض صورة الشركة جنب رقم المحفظة حسب الرقم */}
                                                <div className="wallet-provider-display">
                                                    <img 
                                                        src={getWalletProviderImage(settings.contact_phone)} 
                                                        alt={getWalletProviderImage(settings.contact_phone)?.includes('etisalat') ? 'اتصالات كاش' : 'فودافون كاش'} 
                                                        className="contact-wallet-image"
                                                        onError={(e) => {
                                                            console.error('خطأ في تحميل صورة الشركة');
                                                            e.target.style.display = 'none';
                                                        }}
                                                    />
                                                    <span className="contact-provider-label">
                                                        {getWalletProviderImage(settings.contact_phone)?.includes('etisalat') ? 'اتصالات كاش' : 'فودافون كاش'}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <Form onSubmit={handleSubmit} className="charge-form">
                                            <Form.Group className="mb-4">
                                                <Form.Label>
                                                    <FontAwesomeIcon icon={faWallet} className="me-2" />
                                                    اختر نوع الاشتراك
                                                </Form.Label>
                                                <div className="amount-options">
                                                    {settings?.available_amounts.map((amount, index) => {
                                                        const labels = ['سعر حصة', 'سعر اشتراك الشهر', 'سعر اشتراك الترم كامل'];
                                                        return (
                                                            <Form.Check
                                                                key={amount}
                                                                type="radio"
                                                                name="amount"
                                                                id={`amount-${amount}`}
                                                                value={amount}
                                                                checked={formData.amount === amount}
                                                                onChange={handleInputChange}
                                                                label={`${amount} جنيه - ${labels[index]}`}
                                                                className="amount-option"
                                                            />
                                                        );
                                                    })}
                                                </div>
                                            </Form.Group>

                                            <Form.Group className="mb-4">
                                                <Form.Label>
                                                    <FontAwesomeIcon icon={faPhone} className="me-2" />
                                                    رقم الهاتف الذي حولت منه
                                                </Form.Label>
                                                <Form.Control
                                                    type="tel"
                                                    name="phone_number"
                                                    value={formData.phone_number}
                                                    onChange={handleInputChange}
                                                    placeholder="أدخل رقم الهاتف الذي حولت منه"
                                                    required
                                                />
                                            </Form.Group>

                                            <Form.Group className="mb-4">
                                                <Form.Label>
                                                    <FontAwesomeIcon icon={faImage} className="me-2" />
                                                    صورة إيصال التحويل
                                                </Form.Label>
                                                <Form.Control
                                                    type="file"
                                                    name="image"
                                                    onChange={handleImageChange}
                                                    accept="image/jpeg,image/png,image/jpg,image/gif"
                                                    required
                                                />
                                                <Form.Text className="text-muted">
                                                    الصيغ المسموحة: JPEG, PNG, JPG, GIF. الحجم الأقصى: 10 ميجابايت
                                                </Form.Text>
                                            </Form.Group>

                                            {previewImage && (
                                                <div className="image-preview mb-4">
                                                    <img src={previewImage} alt="معاينة الصورة" />
                                                </div>
                                            )}

                                            <Button 
                                                type="submit" 
                                                className="submit-btn w-100"
                                                disabled={isLoading}
                                            >
                                                {isLoading ? (
                                                    <>
                                                        <Spinner animation="border" size="sm" className="me-2" />
                                                        جاري الإرسال...
                                                    </>
                                                ) : (
                                                    <>
                                                        <FontAwesomeIcon icon={faUpload} className="me-2" />
                                                        إرسال طلب الشحن
                                                    </>
                                                )}
                                            </Button>
                                        </Form>
                                    </>
                                )}

                               
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ScrollTopButton />
        </>
    );
}

export default ChargeRequest;
